import React from "react";
import style from "./part5.module.css";
import { ChevronRightIcon, WarningIcon, ViewIcon } from "@chakra-ui/icons";

export const Part5 = () => {
  return (
    <div className={style.Part5}>
      <div>
        <div className={style.first}>
          <img src="https://buffer.com/resources/content/images/size/w600/2022/12/twitter-threads-buffer.jpg" />
        </div>
        <div className={style.second}>
          Publications <ChevronRightIcon /> <b>Flow</b>
        </div>
        <div className={style.head}>
          New to Buffer: Twitter Threads Scheduling
        </div>
        <div className={style.flex1}>
          <p>Nov 29, 2022</p>
          <p>
            <ViewIcon /> 10 min read
          </p>
          <p>
            <WarningIcon /> Buffer News
          </p>
        </div>
        <div className={style.third}>
          Thread scheduling is the newest addition to Buffer s suite of organic
          marketing tools for Twitter You can now draft unlimited length threads
          with Buffer
        </div>
        <div className={style.flex2}>
          <img src="https://buffer.com/resources/content/images/size/w30/2021/08/mike_e.png" />
          <div>
            <p>Mike Eckstein</p>
          </div>
        </div>
      </div>

      <div>
        <div className={style.first}>
          <img src="https://buffer.com/resources/content/images/size/w600/2022/12/pexels-erik-karits-3732494--1-.jpg" />
        </div>
        <div className={style.second}>
          Publications <ChevronRightIcon /> <b>Open</b>
        </div>
        <div className={style.head}>
          Spotlighting Culture in Thailand From a Buffer Teammate
        </div>
        <div className={style.flex1}>
          <p>Dec 14, 2022</p>
          <p>
            <ViewIcon /> 8 min read
          </p>
          <p>
            <WarningIcon /> Flow
          </p>
        </div>
        <div className={style.third}>
          At Buffer we regularly share cultural spotlights to connect our global
          team and help us understand one another at a deeper level Ben one of.
        </div>
        <div className={style.flex2}>
          <img src="https://buffer.com/resources/content/images/size/w30/2022/12/Blog_Guest-Contributors--13-.png" />
          <div>
            <p>Ben Maxwell</p>
          </div>
        </div>
      </div>

      <div>
        <div className={style.first}>
          <img src="https://buffer.com/resources/content/images/size/w600/2022/11/ali-kokab-lhyzTHwXS9o-unsplash--1-.jpg" />
        </div>
        <div className={style.second}>
          Publications <ChevronRightIcon /> <b>Resources</b>
        </div>
        <div className={style.head}>
          Buffer turned 12 today! Here are some of our favorite stories,
          memories, and lessons
        </div>
        <div className={style.flex1}>
          <p>Dec 12, 2022</p>
          <p>
            <ViewIcon /> 6 min read
          </p>
          <p>
            <WarningIcon /> Flow
          </p>
        </div>
        <div className={style.third}>
          Today marks Buffer s 12th anniversary For the occasion teammates
          shared their favorite memories stories and lessons from working at
          Buffer over the last twelve
        </div>
        <div className={style.flex2}>
          <img src="https://buffer.com/resources/content/images/size/w30/2022/03/B6060E07-7A0E-4C6C-82EE-C654EA065314_1_102_o.jpeg" />
          <div>
            <p>Tamilore Oladipo</p>
          </div>
        </div>
      </div>

      <div>
        <div className={style.first}>
          <img src="https://buffer.com/resources/content/images/size/w600/2022/11/Blog-Graphic--1.png" />
        </div>
        <div className={style.second}>
          Publications <ChevronRightIcon /> <b>Resources</b>
        </div>
        <div className={style.head}>
          Introducing Ideas: Creating Content Just Got 84 Hours Faster
        </div>
        <div className={style.flex1}>
          <p>Nov 29, 2022</p>
          <p>
            <ViewIcon /> 3 min read
          </p>
          <p>
            <WarningIcon /> Flow
          </p>
        </div>
        <div className={style.third}>
          Here s one thing most of us agree on creating content is time
          consuming Last month I spoke to a bunch of Buffer fans and
        </div>
        <div className={style.flex2}>
          <img src="https://buffer.com/resources/content/images/size/w30/2022/05/Headshots-on-brand-colors-2.png" />
          <div>
            <p>Phill Agnew</p>
          </div>
        </div>
      </div>

      <div>
        <div className={style.first}>
          <img src="https://buffer.com/resources/content/images/size/w600/2022/11/Blog-Graphic--2.png" />
        </div>
        <div className={style.second}>
          Publications <ChevronRightIcon /> <b>Resources</b>
        </div>
        <div className={style.head}>
          26 Great Ideas For Social Media Posts That You Can Steal
        </div>
        <div className={style.flex1}>
          <p>Nov 29, 2022</p>
          <p>
            <ViewIcon /> 3 min read
          </p>
          <p>
            <WarningIcon /> Flow
          </p>
        </div>
        <div className={style.third}>
          Earlier today we launched Ideas With Ideas you can store all your
          great ideas tweak them until they re ready and drop them straight into
        </div>
        <div className={style.flex2}>
          <img src="https://buffer.com/resources/content/images/size/w30/2022/05/Headshots-on-brand-colors-2.png" />
          <div>
            <p>Phill Agnew</p>
          </div>
        </div>
      </div>

      <div>
        <div className={style.first}>
          <img src="https://buffer.com/resources/content/images/size/w600/2022/11/1.-Blog-header-graphic--5-.png" />
        </div>
        <div className={style.second}>
          Publications <ChevronRightIcon /> <b>Resources</b>
        </div>
        <div className={style.head}>
          Introducing Ideas: Creating Content Just Got 84 Hours Faster
        </div>
        <div className={style.flex1}>
          <p>Nov 29, 2022</p>
          <p>
            <ViewIcon /> 3 min read
          </p>
          <p>
            <WarningIcon />
            Buffer News
          </p>
        </div>
        <div className={style.third}>
          Schedule new updates to appear on your Start Page to beat the
          algorithm and get the reach you deserve oh and it s included for
        </div>
        <div className={style.flex2}>
          <img src="https://buffer.com/resources/content/images/size/w30/2022/05/Headshots-on-brand-colors-2.png" />
          <div>
            <p>Phill Agnew</p>
          </div>
        </div>
      </div>
    </div>
  );
};
